import Grid from "@mui/material/Grid";
import { Box, Stack } from "@mui/material";
import { LabelTemplate } from "./styles/table";
import { Employee } from "../types/processTypes";

import { BasicPostAppliedNoLabels } from "./components/basic/BasicPostApplied";
import {
  BasicDetailNoLabels,
  BasicDetailNoLabels2,
} from "./components/basic/BasicDetail";
import { BasicLanguageNoLabels } from "./components/basic/BasicLanguage";
import { BasicSkillsNoLabels } from "./components/basic/BasicSkills";
import { BasicPassportNoLabels } from "./components/basic/BasicPassport";
import { BasicNameOnly } from "./components/basic/BasicFullName";
import { BasicFaceFixed } from "./components/basic/BasicFace";
import { BasicStandFixed } from "./components/basic/BasicStand";
import { BasicPassportScanNoBroker } from "./components/basic/BasicPassportScan";
import { Company } from "../../setups/types/setupTypes";

interface Props {
  selectedCompany: Company;
  currentEmployee: Employee;
  backgroundColor: string;
  cvTemplate: LabelTemplate;
  office: string;
}

function WaadaTemplate({ currentEmployee, cvTemplate, office }: Props) {
  const transparent = {
    ...cvTemplate,
    transparentTableBackground: true,
  };

  return (
    <>
      <Box id="personalData" sx={{ p: 1 }}>
        <Grid
          container
          spacing={0}
          sx={{
            p: 0,
            background:
              office === "alamri"
                ? "url(/alamri_single_full.jpg)"
                : office === "waada"
                  ? "url(/waada_single_full.jpg)"
                  : "url(/almansa_single_full.jpg)",
            backgroundSize: "100% 100%",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            minHeight: "1300px",
            alignItems: "flex-start",
            alignContent: "flex-start",
            justifyContent: "flex-start",
          }}
        >
          {/* Header: name / salary / passport + face */}
          <Grid container item xs={12} sx={{ alignSelf: "flex-start" }}>
            <Grid
              container
              item
              xs={9}
              sx={{ mt: 15, pb: 0 }}
              spacing={0}
              alignItems="center"
            >
              {cvTemplate && currentEmployee && (
                <>
                  <Grid item xs={12}>
                    <BasicNameOnly
                      currentEmployee={currentEmployee}
                      template={transparent}
                    />
                  </Grid>
                  <Grid item xs={12} sx={{ pt: 3 }}>
                    <BasicPostAppliedNoLabels
                      currentEmployee={currentEmployee}
                      template={transparent}
                      showHeader={false}
                      showProfession={false}
                      showSalary={true}
                      showContractPeriod={false}
                      showEmployeeTelephone={false}
                    />
                  </Grid>
                  <Grid item xs={12} sx={{ pt: 3 }}>
                    <BasicPassportNoLabels
                      currentEmployee={currentEmployee}
                      template={transparent}
                      showHeader={false}
                      showPassportNumber={true}
                      showIssueDate={false}
                      showPlaceOfIssue={false}
                      showExpiryDate={false}
                    />
                  </Grid>
                </>
              )}
            </Grid>

            <Grid item xs={3} sx={{ pt: 8, pl: 4 }}>
              {cvTemplate && currentEmployee && (
                <BasicFaceFixed
                  currentEmployee={currentEmployee}
                  template={transparent}
                />
              )}
            </Grid>
          </Grid>

          {/* Body: stand | personal info | passport scan */}
          <Grid container item xs={12} sx={{ alignSelf: "flex-start" }}>
            <Grid item xs={3}>
              {cvTemplate && currentEmployee && (
                <Stack
                  spacing={cvTemplate.spacing}
                  sx={{
                    alignItems: "center",
                    mt: 14,
                    pl: 5,
                  }}
                >
                  <BasicStandFixed
                    currentEmployee={currentEmployee}
                    template={transparent}
                  />
                </Stack>
              )}
            </Grid>

            <Grid item xs={5} sx={{ pt: 12, pl: 7, pr: 1 }}>
              {cvTemplate && currentEmployee && (
                <BasicDetailNoLabels2
                  currentEmployee={currentEmployee}
                  template={transparent}
                  showHeader={false}
                  showReference={false}
                  showNationality={true}
                  showPassportNumber={false}
                  showReligion={true}
                  showDateOfBirth={true}
                  showAge={true}
                  showPlaceOfBirth={true}
                  showMaritalStatus={true}
                  showNumberOfChildren={true}
                  showWeightHeight={true}
                  showComplexion={false}
                  showEducation={true}
                  showLivingTown={false}
                  showEmployeeTelephone={true}
                  showContactName={false}
                  showContactTelephone={false}
                />
              )}
            </Grid>

            <Grid item xs={4} sx={{ pt: 15, pr: 2 }}>
              {cvTemplate && currentEmployee && (
                <BasicPassportScanNoBroker
                  currentEmployee={currentEmployee}
                  template={{
                    ...cvTemplate,
                    passportWidth: "98%",
                    passportHeight: "420px",
                  }}
                />
              )}
            </Grid>
          </Grid>

          {/* Bottom: languages | skills */}
          <Grid container item xs={12}>
            <Grid
              item
              xs={5}
              sx={{
                pt:
                  currentEmployee?.workExperience &&
                  currentEmployee?.workExperience?.length <= 1
                    ? 12
                    : 10,
                pl: 2,
              }}
            >
              {cvTemplate && currentEmployee && (
                <BasicLanguageNoLabels
                  currentEmployee={currentEmployee}
                  template={transparent}
                  showEducation={false}
                />
              )}
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                pt:
                  currentEmployee?.workExperience &&
                  currentEmployee?.workExperience?.length <= 1
                    ? 11
                    : 9,
                pr: 2,
              }}
            >
              {cvTemplate && currentEmployee && (
                <BasicSkillsNoLabels
                  currentEmployee={currentEmployee}
                  template={transparent}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default WaadaTemplate;
